module.exports = __webpack_public_path__ + "img/nuggets.124648ad.jpg";